import state from "./state";
import mutations from "./mutations";
import actions from './actions.js';
import getters from './getters.js';

const patientAssessment = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

export default patientAssessment;
